<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  :clearable="true"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerCodeList"
                label="Customer"
                @click="showCustomerCodes()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <v-layout row>
              <v-flex sm2 pt-3>Sale Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                saleAmount | decFormat
              }}</v-flex>
              <v-flex sm2 pl-5
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Sale')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Sale Discount Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                saleDiscountAmount | decFormat
              }}</v-flex>
              <v-flex sm2 pl-5
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Sale Discount')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Sale Return Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                saleReturnAmount | decFormat
              }}</v-flex>
              <v-flex sm2 pl-5
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Sale Return')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Sale Return Discount Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                saleReturnDiscountAmount | decFormat
              }}</v-flex>
              <v-flex sm2 pl-5
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Sale Return Discount')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Sale Expense Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                saleExpenseAmount | decFormat
              }}</v-flex>
              <v-flex sm2 pl-5
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Sale Expense')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Credit Received Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                creditReceivedAmount | decFormat
              }}</v-flex>
              <v-flex sm2 pl-5
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Credit Received')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Advanced Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                advancedAmount | decFormat
              }}</v-flex>
              <v-flex sm2 pl-5
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Advanced')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Net Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                netAmount | decFormat
              }}</v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!--detail list dialog-->
    <v-dialog v-model="showDetailListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!--print and export section-->
          <v-btn
            color="primary"
            :loading="buttonLoading"
            @click="detailPrintAll('printReport')"
            >Print All</v-btn
          >
          <v-btn
            color="primary"
            :loading="printAllLoading"
            @click="detailExportAll()"
            >Export All</v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!--detail list section-->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="detailList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{
                      props.item.issueDateInMilliSecond | format-ms-date
                    }}
                  </td>
                  <td>{{ props.item.refNo }}</td>
                  <td style="text-align: right">
                    {{ props.item.amount | decFormat }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--print-->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Account Receivable(Finance) Report [{{ detailType }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Date From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Reported Date: [{{ currentDate }}]
        </p>
      </div>
      <br />
      <div style="text-align: left">
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Sale'"
        >
          {{ detailType }} Amount :
          {{ saleAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Sale Discount'"
        >
          {{ detailType }} Amount :
          {{ saleDiscountAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Sale Return'"
        >
          {{ detailType }} Amount :
          {{ saleReturnAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Sale Return Discount'"
        >
          {{ detailType }} Amount :
          {{ saleReturnDiscountAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Sale Expense'"
        >
          {{ detailType }} Amount :
          {{ saleExpenseAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Credit Received'"
        >
          {{ detailType }} Amount :
          {{ creditReceivedAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Advanced'"
        >
          {{ detailType }} Amount :
          {{ advancedAmount | decFormat }}
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">
                Ref No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in detailprintList" :key="i">
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDateInMilliSecond | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.refNo }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.amount | decFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Customer Code list dialog -->
    <v-dialog
      v-model="showCustomerCodeListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="customerCodeQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="customerCodeQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomerCode">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- CustomerCode List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedCustomerCodeList"
                :headers="customerCodeHeaders"
                :items="customerCodeList"
                select-all
                class="elevation-1"
                :loading="showListLoading"
                :total-items="customerCodetotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="customerCodepagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAllCode"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedCustomerCodeList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.address }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setCustomerCode">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { customerService } from "../../services/customer-service";
import { shopService } from "../../services/shop-service";
import { accountReceivableService } from "../../services/account-receivable-service";

export default {
  name: "AccountReceivableFinanceReport",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showCustomerCodeListDialog: false,
    showDetailListDialog: false,
    showListLoading: false,
    buttonLoading: false,
    printAllLoading: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Account Receivable (Finance) Report",
        disabled: true,
      },
    ],
    customerCodeHeaders: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Address", value: "address" },
    ],
    headers: [
      { text: "Date", align: "left", value: "temp.issueDate" },
      { text: "Ref No", align: "left", value: "temp.refNo" },
      { text: "Amount", align: "left", value: "temp.amount" },
    ],
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    queryParams: {
      fromDate: "",
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      customerIds: [],
    },
    clonequeryParams: {},
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    customerCodeQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
    },
    customerCodepagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    customerCodetotalRows: 0,
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    selectedCustomerCodeList: [],
    customerCodeList: [],
    shopList: [],
    detailList: [],
    detailprintList: [],
    saleAmount: 0,
    saleDiscountAmount: 0,
    saleReturnAmount: 0,
    saleReturnDiscountAmount: 0,
    saleExpenseAmount: 0,
    creditReceivedAmount: 0,
    advancedAmount: 0,
    netAmount: 0,
    detailType: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getDetailList();
      },
      deep: true,
    },
    customerCodepagination: {
      handler() {
        this.getCustomerCodeList();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.customerIds) {
      this.queryParams.customerIds = this.$route.query.customerIds;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },
  methods: {
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "account-receivable-finance-report",
        query: this.queryParams,
      });
      this.getAccountReceivableFinanceReportSummary();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    getAccountReceivableFinanceReportSummary() {
      this.showListLoading = true;
      accountReceivableService
        .getAccountReceivableFinanceReportSummary(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.saleAmount = res.data.saleAmount;
            this.saleDiscountAmount = res.data.saleDiscountAmount;
            this.saleReturnAmount = res.data.saleReturnAmount;
            this.saleReturnDiscountAmount = res.data.saleReturnDiscount;
            this.saleExpenseAmount = res.data.saleExpenseAmount;
            this.creditReceivedAmount = res.data.creditReceivedAmount;
            this.advancedAmount = res.data.advancedAmount;
            this.netAmount = res.data.netAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showDetail(detailType) {
      this.detailType = detailType;
      this.getDetailList().then(
        (this.showDetailListDialog = !this.showDetailListDialog)
      );
    },
    getDetailList() {
      this.detailList = [];
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      if (this.detailType == "Sale") {
        return accountReceivableService
          .getSaleAmouontDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.accountReceivableFinanceReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Sale Discount") {
        return accountReceivableService
          .getSaleDiscountAmouontDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.accountReceivableFinanceReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Sale Return") {
        return accountReceivableService
          .getSaleReturnAmouontDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.accountReceivableFinanceReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Sale Return Discount") {
        return accountReceivableService
          .getSaleReturnDiscountAmouontDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.accountReceivableFinanceReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Sale Expense") {
        return accountReceivableService
          .getSaleExpenseAmouontDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.accountReceivableFinanceReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Credit Received") {
        return accountReceivableService
          .getCreditReceivedDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.accountReceivableFinanceReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Advanced") {
        return accountReceivableService
          .getAdvancedAmountDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.accountReceivableFinanceReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    detailPrintAll(divName) {
      this.reprintReport().finally(() => {
        var printContents = document.getElementById(divName).innerHTML;
        var reprintWindow = window.open(
          "",
          "MsgWindow",
          "width=500,height=500"
        );
        reprintWindow.document.write(printContents);
        setTimeout(() => {
          reprintWindow.print();
          reprintWindow.close();
        }, 600);
        this.buttonLoading = false;
      });
    },
    reprintReport() {
      this.buttonLoading = true;
      this.detailprintList = [];
      let order = this.pagination.descending ? "desc" : "asc";
      return accountReceivableService
        .getAccountReceivableFinanceReportPrint(
          this.clonequeryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order,
          this.detailType
        )
        .then((res) => {
          if (res.data) {
            this.detailprintList = res.data.accountReceivableFinanceReportList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    detailExportAll() {
      this.printAllLoading = true;
      accountReceivableService
        .getAccountReceivableFinanceReportExcelExport(
          this.clonequeryParams,
          this.detailType
        )
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
    showCustomerCodes() {
      // Clean query params
      this.customerCodeQueryParams.code = "";
      this.customerCodeQueryParams.name = "";
      this.selectedCustomerCodeList = [];
      this.queryParams.customerIds = [];
      this.getCustomerCodeList().then(
        (this.showCustomerCodeListDialog = !this.showCustomerCodeListDialog)
      );
    },
    toggleAllCode() {
      if (this.selectedCustomerCodeList.length) {
        this.selectedCustomerCodeList = [];
      } else {
        this.showCustomerCodeListDialog = this.customerCodeList.slice();
      }
    },
    getCustomerCodeList() {
      this.showListLoading = true;
      let order = this.customerCodepagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerCodeQueryParams,
          this.customerCodepagination.page,
          this.customerCodepagination.rowsPerPage,
          this.customerCodepagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerCodeList = res.data.customerList;
            this.customerCodetotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setCustomerCode() {
      if (this.selectedCustomerCodeList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerCodeList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerCodeListDialog = !this.showCustomerCodeListDialog;
    },
    onSearchCustomerCode() {
      this.customerCodeQueryParams.page = this.customerCodepagination.page;
      this.customerCodeQueryParams.size =
        this.customerCodepagination.rowsPerPage;
      this.getCustomerCodeList();
    },
  },
};
</script>
